import * as React from "react";
import { ArrayString } from "../../../schema/types/org/input";
import { cloneDeep, get } from "lodash";
import { store } from "../../../store";
import { formSetValue, formTriggerValidation } from "./utils";
import { Button } from "antd";
import { MinusCircleOutlined } from "@ant-design/icons";
import { CpInput } from "./CpInput";
import { useCpFormContext } from "../../../components/form/useCpFormContext";
import { v4 as uuidv4 } from "uuid";

interface Props {
  name: string;
  item: ArrayString;
  index: number;
}
export const CpArrayStringItem: React.FC<Props> = React.memo(
  ({ name, item, index }) => {
    const { id: formId } = useCpFormContext();

    function remove() {
      const form = store.getState().form.instances[formId];
      const values = form.values;

      const items = get(values, name) || [];
      let _items = cloneDeep(items);
      _items = _items.filter((i) => i.id !== item.id);
      formSetValue(formId, `${name}`, _items);

      formTriggerValidation(formId);
    }

    function parsePastedValues(text: string): string[] {
      for (const sep of [/\r?\n/, /,/, / /]) {
        const parts = text.split(sep).map((s) => s.trim()).filter(Boolean);
        if (parts.length >= 2) return parts;
      }
      return [text.trim()].filter(Boolean);
    }

    function handlePaste(e: React.ClipboardEvent<HTMLInputElement>) {
      const pastedText = e.clipboardData?.getData("text") || "";
      const values = parsePastedValues(pastedText);
      if (values.length <= 1) return;

      e.preventDefault();
      const form = store.getState().form.instances[formId];
      const items: ArrayString[] = get(form.values, name) || [];
      const _items = cloneDeep(items);
      const idx = _items.findIndex((i) => i.id === item.id);
      if (idx !== -1) _items[idx] = { ..._items[idx], value: values[0] };
      _items.splice(idx + 1, 0, ...values.slice(1).map((v) => ({ id: uuidv4(), value: v })));
      formSetValue(formId, name, _items);
      formTriggerValidation(formId);
    }

    return (
      <div key={item.id} className="mb-1">
        <div className="flex items-center gap-2">
          <CpInput name={`${name}.${index}.value`} onPaste={handlePaste} />
          <Button type={`text`} danger onClick={remove} icon={<MinusCircleOutlined />}></Button>
        </div>
      </div>
    );
  },

  // arepropsequal?
  // (prevProps, nextProps) => {
  //   return (
  //     prevProps.name === nextProps.name &&
  //     prevProps.index === nextProps.index &&
  //     prevProps.item.id === nextProps.item.id &&
  //     prevProps.item.value === nextProps.item.value
  //   );
  // },
);
